import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ImportPnrDetails, ImportPNREntryProprties, ImportPNRIssuanceResponse, ImportPNRListProperties, ImportPnrListProperties } from '../Models/ImportPnrProperties';
import { Agencies_BranchesProperties } from '../Models/AgencyMasterProperties';
import { PassengerCreationResponse } from '../Models/BookingPassengerTicketIssuanceProperties';
import { TicketIssuanceProperties, TicketPnrRights } from '../Models/TicketIssuanceProperties';
import { BookingListProperties } from '../Models/BookingListProperties';

@Injectable({
  providedIn: 'root'
})
export class ImportPnrService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
    showSpinner: any;
  constructor(private http: HttpClient) { }
  GetPNRByID(value, agencyId, UserId): Observable<ImportPnrDetails> {
    return this.http.get<ImportPnrDetails>(this.baseUrl + '/ImportPNR/GetImportPnrByID/' + value + "/" + agencyId + "/" + UserId).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }
  getBookingList(bookingNew): Observable<BookingListProperties[]> {
    return this.http.post<BookingListProperties[]>(this.baseUrl + '/ImportPNR/GetBookingList', bookingNew)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  //GetImportList(value): Observable<ImportPnrListProperties[]> {
  //  return this.http.get<ImportPnrListProperties[]>(this.baseUrl + '/ImportPNR/GetAllImportPnrListDetails/' + value).pipe(map((data: any) => {
  //    return data;
  //  }), catchError(error => { return throwError(error); }))
  //}
  GetAllAgencies(param, userId): Observable<Agencies_BranchesProperties[]> {
    return this.http.get<Agencies_BranchesProperties[]>(this.baseUrl + '/AgencyMaster/GetAllAgencies/' + param + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateImportPnrPassengerDOB(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/ImportPNR/UpdateImportPnrPassengerDOB', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  UpdateImportPnrPassengerPassport(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/ImportPNR/UpdateImportPnrPassengerPassport', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }




  getImportPNRrequestId(importID): Observable<ImportPNRListProperties> {
    return this.http.get<ImportPNRListProperties>(this.baseUrl + '/ImportPNR/GetImportPNRDetailsFromOfflineList/' + importID)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  UpdateOfflineTktRequest(offlineBookingId): Observable<boolean> {

    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/UpdateOnlineTicketRequest/' + offlineBookingId, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }


  IssueGalileoFlight(obj): Observable<ImportPNRIssuanceResponse> {
    return this.http.post<ImportPNRIssuanceResponse>(this.baseUrl + '/ImportPNR/IssueGalileoFlight', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }

  CheckTktPnrRightsAgainstAgencyAndUserId(isAgency, param): Observable<TicketPnrRights> {
    return this.http.get<TicketPnrRights>(this.baseUrl + '/TicketIssuance/GetTicketPnrRights/' + isAgency + "/" + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  CheckTktPnrRightsAgainstImportPNR(isAgency, param, importId): Observable<TicketPnrRights> {
    return this.http.get<TicketPnrRights>(this.baseUrl + '/ImportPNR/CheckTktPnrRightsAgainstImportPNR/' + isAgency + "/" + param + "/" + importId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetAllImportPnrEntry(): Observable<ImportPNREntryProprties> {
    return this.http.get<ImportPNREntryProprties>(this.baseUrl + '/ImportPnrEntry/ImportPnrEntryGetAll').pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }


  CreateImportPnrEntryData(newobj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/ImportPnrEntry/CreateImportPnrEntryData', newobj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  UpdateImportPnrEntry(userObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/ImportPnrEntry/UpdateImportPnrEntryDetail', userObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  DeleteImportPnrEntryDetails(userObj, userid): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/ImportPnrEntry/DeleteImportPnrEntry/' + userObj + '/' + userid, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  getOfflineBookingbyPNRAllData(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/GetOfflineBookingbyPNRAllData', obj, this.httpOptions)
      .pipe(map((data: any) => {
        //  console.log(data);
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }

  UpdatePassengerImport(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/ImportPNR/UpdatePassengerDetails', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }),
        catchError(error => { return throwError(error); }))
  }
  getBookingInfo(ticketReqObj): Observable<TicketIssuanceProperties> {
    return this.http.post<TicketIssuanceProperties>(this.baseUrl + '/TicketIssuance/GetBookingInfo', JSON.stringify(ticketReqObj), this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
}
